import React from 'react';
import { Modal } from '@ori/online-modal';
import { default as bemCssModules } from 'bem-css-modules';
import * as OpenMultishadeDialogEvent from '@ori-events/open-multishade-dialog';
import { useStore } from './store/AppStore';
import { Content } from './components/Content/Content';
import { ErrorNotification } from './components/ErrorNotification/ErrorNotification';
import { default as AppStyles } from './App.module.css';
import '@ori/online-modal/build/style.css';
import 'simplebar/dist/simplebar.min.css';
const style = bemCssModules(AppStyles);
bemCssModules.setSettings({
    modifierDelimiter: '--',
    throwOnError: false,
});
export const App = () => {
    const [isMultishadeDialogOpen, setMultishadeDialogVisibility,] = React.useState(false);
    const { setProduct } = useStore();
    const closeMultishadeDialog = () => setMultishadeDialogVisibility(false);
    const onModalOpen = (event) => {
        setProduct(event.detail.name, event.detail.brand, event.detail.shades);
        setMultishadeDialogVisibility(true);
    };
    React.useEffect(() => {
        window.addEventListener(OpenMultishadeDialogEvent.Name, onModalOpen);
        return () => {
            window.addEventListener(OpenMultishadeDialogEvent.Name, onModalOpen);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(Modal, { onClose: closeMultishadeDialog, isCustomContent: true, isOpen: isMultishadeDialogOpen },
        React.createElement("div", { className: style('close'), onClick: closeMultishadeDialog },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.1", width: "20", height: "20", viewBox: "0 0 44 64" },
                React.createElement("path", { d: "M24.917 33.375l18.48-18.48c0.806-0.806 0.806-2.111 0-2.917s-2.111-0.806-2.916 0l-18.48 18.48-18.48-18.48c-0.806-0.806-2.111-0.806-2.917 0s-0.806 2.111 0 2.917l18.48 18.48-18.48 18.48c-0.806 0.806-0.806 2.111 0 2.917 0.403 0.403 0.929 0.604 1.458 0.604s1.055-0.201 1.458-0.604l18.48-18.48 18.48 18.48c0.403 0.403 0.929 0.604 1.458 0.604s1.055-0.201 1.458-0.604c0.806-0.806 0.806-2.111 0-2.917l-18.48-18.48z" }))),
        React.createElement(ErrorNotification, null),
        React.createElement(Content, null)));
};
